module.exports = __webpack_public_path__ + "img/equate_daytime_and_nighttime_cold_flu_multi_symptom_relief.5fbcd6c3.png";